import { ElementViewTemplate, html, when } from '@microsoft/fast-element';
import { NatGenHamburgerButton } from './hamburger-button';

export function hamburgerButtonTemplate<T extends NatGenHamburgerButton>(): ElementViewTemplate<T> {
    return html<T>`
    <template role="button">
        <natgen-button
            class="nav-button"
            part="nav-button"
            variant="${x => x.variant}"
            color="${x => x.color}"
            @click="${(x, e) => x.toggleOpened(e.event)}"
        >
            ${when(x => !x.opened, html`<slot name="openIcon" class="openIcon"><natgen-icon name="hamburger-button" size="6"></natgen-icon></slot>`)}
            ${when(x => x.opened, html`<slot name="closeIcon" class="closeIcon"><natgen-icon name="times" size="6"></natgen-icon></slot>`)}
        </natgen-button>

        <div class="overlay" part="overlay" @click="${(x, e) => x.toggleOpened(e.event, true)}">
            <slot></slot>
        </div>
    </template>
`};
